export const termsOfUse = `
<!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN">
<html>
<head>
	<meta http-equiv="content-type" content="text/html; charset=utf-8"/>
	<title></title>
	<meta name="generator" content="LibreOffice 6.4.7.2 (Linux)"/>
	<meta name="created" content="2023-05-02T14:35:00"/>
	<meta name="changedby" content="Guilherme Hackerott"/>
	<meta name="changed" content="2023-05-02T16:15:00"/>
	<meta name="AppVersion" content="16.0000"/>
	<meta name="DocSecurity" content="0"/>
	<meta name="HyperlinksChanged" content="false"/>
	<meta name="LinksUpToDate" content="false"/>
	<meta name="ScaleCrop" content="false"/>
	<meta name="ShareDoc" content="false"/>
	<style type="text/css">
		@page { size: 21.59cm 27.94cm; margin-left: 2.54cm; margin-right: 2.54cm; margin-top: 0.64cm; margin-bottom: 0.64cm }
		p { margin-bottom: 0.25cm; direction: ltr; line-height: 115%; text-align: left; orphans: 2; widows: 2; background: transparent }
		a:link { color: #0000ff; text-decoration: underline }
	</style>
</head>
<body lang="pt-BR" link="#0000ff" vlink="#800000" dir="ltr">
<div title="header">
	<p align="center" style="margin-bottom: 1rem; line-height: 100%">
	<font color="#666666"><font face="Arial, serif"><font size="1" style="font-size: 8pt">Última atualização: 17/09/2026</font></font></font></p>
</div>
<p align="center" style="margin-bottom: 0cm; line-height: 150%"><font color="#38761d"><font face="Arial, serif"><font size="4" style="font-size: 14pt"><i><b>TERMOS
DE USO DA PLATAFORMA E SERVIÇOS DA VERT ECOTECH S.A.</b></i></font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ol type="I">
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>TERMOS
	E CONDIÇÕES GERAIS</b></font></font></p>
</ol>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Bem-vindo
à </font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
Ecotech,</b></font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Leia
atentamente as disposições abaixo. Lembre-se que a utilização dos
nossos serviços está condicionada à plena aceitação dos termos e
condições gerais previstos neste instrumento (“Contrato”,
“Acordo”, “Termo” ou “Termos”) e em nossa Política de
Privacidade.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Por
intermédio do presente Acordo, </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
ECOTECH S.A.</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">,
(“</font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">”
ou “Contratada”) apresenta as condições gerais de uso de sua
Plataforma (“Plataforma” ou “</font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">”)
e dos Serviços </font></font></font><font face="Arial, serif"><font size="3" style="font-size: 12pt">nela</font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
disponibilizados (“Serviços”) por qualquer pessoa (“Usuário”,
“Cliente” ou “Contratante”).</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Os
termos “nós” ou “nosso” referem-se à </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">.
Os termos “você”, “seu”, referem-se a qualquer indivíduo ou
entidade que aceite estes Termos, tenha acesso à sua conta ou
utilize a Plataforma ou os Serviços nela contidos.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">O
simples uso da Plataforma ou fruição dos Serviços nela encontrados
</font></font></font><font face="Arial, serif"><font size="3" style="font-size: 12pt">implica</font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
na aceitação eletrônica destes Termos e da Política de
Privacidade da </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
Ecotech</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">.
Os termos “você”, “seu”, referem-se a qualquer indivíduo ou
entidade que aceite estes termos, significando que você leu,
entendeu, confirmou e concordou em se obrigar ao presente Acordo. </font></font></font>
</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Os
presentes Termos entram em vigor a partir da data do uso da
Plataforma ou da data da contratação dos Serviços.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">A
utilização da Plataforma também está condicionada à leitura,
compreensão e aceitação, pelo Usuário, da nossa </font></font></font><font color="#0070c0"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><i><u>Política
de Privacidade</u></i></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">,
a qual faz parte do presente Acordo. Ela dispõe sobre a forma como
coletamos, usamos e compartilhamos os conteúdos e informações que
nos são disponibilizadas. Além disso, alguns aspectos específicos
dos serviços podem estar sujeitos a Contratos Adicionais adotados
pela </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
(Contrato de Licença de Uso de Software ou Contrato de Prestação
de Serviços Adicionais), os quais, se o caso, incorporam-se aos
presentes Termos de Uso por esta referência.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Este
Contrato poderá ser atualizado de tempos em tempos, conforme
previsto; a continuidade da utilização da Plataforma ou dos Serviços,
após a realização de qualquer alteração de seus
Termos, demonstrará a inequívoca ciência e aceitação, pelo
Usuário, das novas regras estabelecidas.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Caso
você não concorde em estar vinculado aos termos e condições
deste Acordo, da nossa </font></font></font><font color="#0070c0"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><i><u>Política
de Privacidade</u></i></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
ou dos Contratos Adicionais (incluindo as versões futuras dos
documentos), não use ou acesse (ou não continue a usar e acessar) a
Plataforma ou os Serviços.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Em
caso de dúvidas, por favor, entre em contato com a </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ol type="I" start="2">
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>DEFINIÇÕES</b></font></font></font></p>
</ol>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 100%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Os
termos empregados no presente Termo têm as seguintes definições:</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 100%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 100%"><br/>

</p>
<p align="justify" style="margin-left: 1.25cm; margin-bottom: 0cm; line-height: 100%">
<br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 100%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Terceiros
	Atendidos:</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
	</font></font></font><font face="Arial, serif"><font size="3" style="font-size: 12pt">Usuários
	prestadores de serviço</font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">.</font></font></font></p>
</ul>
<p align="justify" style="margin-bottom: 0cm; line-height: 100%"><br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Agentes
	de Apoio:</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
	Terceiros não vinculados à plataforma, ocasionalmente acionados
	durante a execução dos p</font></font></font><font face="Arial, serif"><font size="3" style="font-size: 12pt">rojetos</font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">.
	</font></font></font>
	</p>
</ul>
<p style="margin-left: 1.25cm; margin-bottom: 0cm; line-height: 100%">
<br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 100%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Dados
	Protegidos:</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
	Dados pessoais e dados pessoais sensíveis passíveis de tratamento
	na Plataforma.</font></font></font></p>
</ul>
<p align="justify" style="margin-bottom: 0cm; line-height: 100%"><br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Plataforma</b></font></font><font color="#4d5156"><font face="Arial, serif"><font size="3" style="font-size: 12pt">:
	</font></font></font><font face="Arial, serif"><font size="3" style="font-size: 12pt">é
	um modelo de negócios que funciona por meio de tecnologias.
	Trata-se de um ambiente online que conecta quem produz a quem
	consome, permitindo uma relação de troca, muito além da simples
	compra e venda.</font></font></p>
</ul>
<p style="margin-left: 1.25cm; margin-bottom: 0cm; line-height: 100%">
<br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 100%"><br/>

</p>
<ol type="I" start="3">
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>DA
	PLATAFORMA </b></font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>VERT
	ECOTECH</b></font></font></font></p>
</ol>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">A
Plataforma da </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
permite o gerenciamento online, pel</font></font></font><font face="Arial, serif"><font size="3" style="font-size: 12pt">o
cliente, do status do projeto de geração de créditos de carbono, a
quantidade gerada, a quantidade comercializada, a quantidade
aposentada entre outros benefícios.</font></font></p>
<p align="justify" style="text-indent: 1.27cm; margin-bottom: 0cm; line-height: 150%">
<br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">A
Plataforma da </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
apresenta, ainda, funcionalidades que otimizam a interação e a
comunicação entre </font></font></font><font face="Arial, serif"><font size="3" style="font-size: 12pt">a
empresa e seus clientes</font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">,
os Terceiros Atendidos, bem como viabilizam a implementação de
soluções de</font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><i>
</i></font></font></font><font face="Arial, serif"><font size="3" style="font-size: 12pt"><i>trade</i></font></font><font face="Arial, serif"><font size="3" style="font-size: 12pt">
de créditos de carbono</font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ol type="I" start="4">
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>ELEGIBILIDADE
	</b></font></font></font>
	</p>
</ol>
<p style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">A
Plataforma e os Serviços apenas estão disponíveis a Usuários que
possam firmar contratos válidos legalmente; a violação desta
disposição autoriza o imediato cancelamento da conta do Usuário.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Ao
aceitar este Contrato, o Usuário declara que tem ao menos 18 anos de
idade; é de outra forma reconhecido como podendo legalmente firmar
contratos sob a lei aplicável; não é uma pessoa impedida de
adquirir ou receber os Serviços encontrados nesta Plataforma; e que
leu, compreendeu e concordou com os termos do presente Acordo.</font></font></font></p>
<p style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Ao
celebrar o presente acordo em favor de outra pessoa, empresa ou
entidade legal, o Usuário afirma e garante que possui poderes para
vincular referido terceiro a estes Termos. </font></font></font>
</p>
<p style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ol type="I" start="5">
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>ACESSO
	À PLATAFORMA</b></font></font></font></p>
</ol>
<p style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Para
acessar a plataforma ou utilizar os Serviços, o Usuário deverá ser
cadastrado junto à </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">,
possuindo uma conta com informações de registro verdadeiras,
atuais, precisas e completas, observando-se ainda o seguinte:</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Terceiros</b></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">:
As contas de acesso d</font></font></font><font face="Arial, serif"><font size="3" style="font-size: 12pt">e
prestadores de serviços</font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
serão criadas pela Contratante, com o cadastro dos usuários
primários e fornecimento de credenciais provisórias de utilização,
nos termos do quanto ajustado no Contrato de Licença de Software
celebrado entre as partes.; </font></font></font>
</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>O
usuário deve zelar pela segurança da conta, se comprometendo:</b></font></font></font></p>
<p style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">A
	não transferir ou ceder sua conta a outro Usuário;</font></font></font></p>
</ul>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">A
	não compartilhar sua senha de acesso e a não deixar outra pessoa
	usar sua conta ou realizar qualquer outra atividade que possa
	comprometer a segurança desta mesma, sob pena de responsabilização
	por qualquer dano resultante destas condutas;</font></font></font></p>
</ul>
<p style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">A
	comunicar imediatamente à </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
	ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
	qualquer violação de segurança ou uso não autorizado de sua
	conta. A </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
	Ecotech</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
	Contratada não se responsabiliza por quaisquer prejuízos causados
	pelo uso não autorizado de sua conta do Usuário;</font></font></font></p>
</ul>
<p style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">O
	Usuário, no entanto, poderá ser responsável por quaisquer perdas
	e danos que a </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
	ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
	ou outros sofram devido à sua conta, sejam causados por você, uma
	pessoa autorizada ou uma pessoa não autorizada;</font></font></font></p>
</ul>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Ao
	fornecer seu endereço de e-mail à </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
	ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">,
	o Usuário concorda com o encaminhamento de avisos relacionados a
	plataforma e aos Serviços disponibilizados, incluindo os de
	natureza legal, dispensando a utilização de correio tradicional;</font></font></font></p>
</ul>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">A
	</font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
	ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
	somente utilizará as informações cadastrais fornecidas pelos
	Usuários para a realização de atividades expressamente permitidas
	pela legislação brasileira e demais aplicáveis e/ou por este
	Acordo;</font></font></font></p>
</ul>
<p style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">A
	</font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
	ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
	se reserva ao direito de, sumariamente, a seu absoluto e exclusivo
	critério, excluir a conta do Usuário, na hipótese de suspeita ou
	constatação de fornecimento de informações falsas,
	desatualizadas ou incompletas; ou, ainda, no caso de violação de
	qualquer dos termos deste Contrato.</font></font></font></p>
</ul>
<p style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Se
	você estiver visitando </font></font></font><font face="Arial, serif"><font size="3" style="font-size: 12pt">esta</font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
	Plataforma de um país diferente do país em que nossos servidores
	estão localizados, as comunicações conosco podem resultar na
	transferência de informações (incluindo informações da conta)
	por meio das fronteiras internacionais. Visitando </font></font></font><font face="Arial, serif"><font size="3" style="font-size: 12pt">esta</font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
	Plataforma e comunicando-se eletronicamente conosco, você concorda
	com tais transferências.</font></font></font></p>
</ul>
<p style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p style="margin-left: 1.25cm; margin-bottom: 0cm; line-height: 100%">
<br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>A Plataforma se reserva ao direito de descredenciar ou excluir o
cadastro do </b></font></font></font><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Usuário</b></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>
nos casos:</b></font></font></font></p>
<p style="margin-left: 1.25cm; margin-bottom: 0cm; line-height: 100%">
<br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Reclamações
	em geral ou cometimento de ilegalidades no exercício de suas
	funções perante os Terceiros Atendidos e/ou </font></font></font><font face="Arial, serif"><font size="3" style="font-size: 12pt">clientes</font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">;</font></font></font></p>
</ul>
<p align="justify" style="margin-left: 1.25cm; margin-bottom: 0cm; line-height: 150%">
<br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Violação
	destes Termos;</font></font></font></p>
</ul>
<p style="margin-left: 1.25cm; margin-bottom: 0cm; line-height: 100%">
<br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Falta
	de pagamento da taxa de serviço;</font></font></font></p>
</ul>
<p style="margin-left: 1.25cm; margin-bottom: 0cm; line-height: 100%">
<br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Desrespeito
	às normas contidas no código de ética ou de conduta aplicável à
	sua classe profissional;</font></font></font></p>
</ul>
<p style="margin-left: 1.25cm; margin-bottom: 0cm; line-height: 100%">
<br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Estar
	sob investigação criminal, notadamente se afeta a possível
	cometimento de crime contra a vida, nos termos do quanto previsto
	pelo Código Penal Brasileiro (arts. 121 a 128). </font></font></font>
	</p>
</ul>
<p style="margin-left: 1.25cm; margin-bottom: 0cm; line-height: 100%">
<br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Da
Boa Utilização da Plataforma</b></font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Você
	concorda em atender às regras de conduta estabelecidas pela </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
	ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
	durante o uso da Plataforma e dos Serviços nela encontrados,
	incluindo qualquer conteúdo enviado, cumprindo este Acordo e todas
	as leis, regras e regulamentos locais, estaduais, nacionais e
	internacionais aplicáveis.</font></font></font></p>
</ul>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Para
	realizar uma boa utilização da Plataforma e dos Serviços nela
	encontrados, você se compromete a não:</font></font></font></p>
</ul>
<p style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Praticar,
	promover ou incentivar qualquer ato ilegal, equivocado, malicioso ou
	discriminatório;</font></font></font></p>
</ul>
<p style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Publicar
	comunicações comerciais não autorizadas no Serviço;</font></font></font></p>
</ul>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Intimidar,
	assediar ou prejudicar qualquer Usuário ou terceiro;</font></font></font></p>
</ul>
<p style="margin-left: 1.25cm; margin-bottom: 0cm; line-height: 100%">
<br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Facilitar
	ou incentivar a violação deste Acordo e nossas demais políticas;</font></font></font></p>
</ul>
<p style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Violar
	os direitos de propriedade intelectual da Plataforma, de qualquer
	Usuário ou de terceiro;</font></font></font></p>
</ul>
<p align="justify" style="margin-left: 1.25cm; margin-bottom: 0cm; line-height: 150%">
<br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Praticar
	nada que possa desabilitar, sobrecarregar ou impedir o funcionamento
	da Plataforma, bem como prejudicar sua aparência ou
	funcionalidades;</font></font></font></p>
</ul>
<p style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">O
	Usuário não copiará e nem distribuirá em nenhum meio nenhuma
	parte dest</font></font></font><font face="Arial, serif"><font size="3" style="font-size: 12pt">a</font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
	Plataforma ou dos Serviços encontrados nela, salvo se
	explicitamente autorizado pela </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
	ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">.</font></font></font></p>
</ul>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">O
	Usuário se compromete a não modificar ou alterar qualquer parte da
	Plataforma ou dos Serviços neles encontrados ou, ainda, de qualquer
	das tecnologias a eles relacionadas.</font></font></font></p>
</ul>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">O
	acesso aos conteúdos veiculados na Plataforma ou Serviços somente
	há de ser realizado através da Plataforma em si, ou conforme a
	</font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
	ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
	possa designar.</font></font></font></p>
</ul>
<p style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Você
	não revenderá nem fornecerá os Serviços para fins comerciais,
	incluindo qualquer tecnologia relacionada à </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
	ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">,
	sem o consentimento prévio explícito por escrito da </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
	ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">.</font></font></font></p>
</ul>
<p style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Você
	está ciente de que a </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
	ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
	pode, de tempos em tempos, lhe telefonar para tratar de sua conta.
	Pelo presente, você concorda em permitir que a </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
	ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">,
	a seu exclusivo critério, grave a totalidade de tais chamadas.</font></font></font></p>
</ul>
<p style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">A
	violação de quaisquer das regras acima ou de outras que, embora
	aqui não descritas, com elas se </font></font></font><font face="Arial, serif"><font size="3" style="font-size: 12pt">assemelham,</font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
	autoriza a </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
	ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
	a proceder a imediata suspensão ou rescisão de sua conta, sem
	prejuízo da adoção das medidas legais cabíveis.</font></font></font></p>
</ul>
<p style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Reserva
de Direitos Adicionais</b></font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">A
	</font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
	ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
	expressamente se reserva ao direito de negar, cancelar, encerrar,
	suspender, bloquear ou modificar o acesso a qualquer Conta ou
	Serviço por qualquer razão, para, dentre outros: a) corrigir erros
	cometidos pela </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
	ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
	na oferta ou entrega de Serviços; b) cumprir ordens judiciais
	contra você e leis, regras e regulamentos aplicáveis; c) cumprir
	solicitações policiais, incluindo solicitações de intimação;
	d) defender-se de ação jurídica ou ameaça de ação jurídica;
	e) evitar qualquer responsabilidade civil ou criminal por parte da
	</font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
	ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">,
	seus administradores, diretores, funcionários e agentes.</font></font></font></p>
</ul>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">A
	</font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
	ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
	reserva-se ao direito de modificar, alterar ou interromper qualquer
	aspecto dest</font></font></font><font face="Arial, serif"><font size="3" style="font-size: 12pt">a</font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
	Plataforma ou dos Serviços, a qualquer momento.</font></font></font></p>
</ul>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">A
		</font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
	ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
	reserva-se ao direito de modificar, suspender ou descontinuar
	temporariamente a Plataforma e os Serviços nela contidos.</font></font></font></p>
</ul>
<p style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">A
	</font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
	ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
	reserva-se ao direito de alterar ou modificar seus preços a
	qualquer momento, sendo certo que tais alterações ou modificações
	serão publicadas online na Plataforma<!-- Há publicação de valores no site? -->
	e entrarão em vigor imediatamente, sem a necessidade de mais
	avisos.</font></font></font></p>
</ul>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Links
para Plataformas de Terceiros</b></font></font></font></p>
<p style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">A
Plataforma </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
ECOTECH </b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">e
os Serviços nele contidos podem conter links para plataformas de
terceiros que não são de propriedade nem controle da </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">.
A </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
não assume qualquer responsabilidade pelo conteúdo, termos e
condições, políticas de privacidade ou práticas de plataformas de
terceiros. Além disso, a </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
não censura nem edita o conteúdo de plataformas de terceiros.
Usando </font></font></font><font face="Arial, serif"><font size="3" style="font-size: 12pt">esta</font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
Plataforma ou os Serviços nela contidos você expressamente isenta
a </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
de toda e qualquer responsabilidade resultante do seu uso de qualquer
plataforma ou serviços de terceiros.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ol type="I" start="6">
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>TRATAMENTO
	DOS DADOS CADASTRAIS</b></font></font></font></p>
</ol>
<p style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Os
dados cadastrais informados pelos Usuários serão tratados de
maneira automatizada, segundo a nossa </font></font></font><font color="#0070c0"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><i><u>Política
de Privacidade</u></i></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">.
</font></font></font><font face="Arial, serif"><font size="3" style="font-size: 12pt">A
referida</font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
política poderá ser modificada, sempre que necessária à sua
adaptação às boas práticas comerciais e às alterações
legislativas ou jurisprudenciais. </font></font></font>
</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">As
informações cadastrais fornecidas somente serão utilizadas para a
realização de atividades lícitas, conforme nossa </font></font></font><font color="#0070c0"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><i><u>Política
de Privacidade</u></i></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><i>,</i></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
e desde que expressamente permitidas pela legislação, por este
Acordo e pelo próprio Usuário.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ol type="I" start="7">
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>ISENÇÃO
	DE RESPONSABILIDADE; LIMITAÇÃO DE RESPONSABILIDADE E INDENIZAÇÃO
	</b></font></font></font>
	</p>
</ol>
<p style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">O
Usuário reconhece e concorda que o uso da Plataforma e dos Serviços
nela contidos se dá a seu risco exclusivo, inclusive no que diz
respeito à qualidade, desempenho, precisão e esforço, e que, na
máxima extensão permitida pela lei aplicável, a Plataforma e os
Serviços são fornecidos “no estado em que se encontram” e
“conforme disponíveis”. A </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
também não garante, dentre outras, que a Plataforma e os Serviços
atenderão às necessidades do Usuário, que o funcionamento da
Plataforma e dos Serviços serão ininterruptos e livres de falhas. </font></font></font>
</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">A
</font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
isenta-se de qualquer responsabilidade em caso de falhas na
disponibilidade, continuidade e utilidade da Plataforma ou dos
Serviços nela contidos, que, por questões técnicas e
operacionais, estejam fora do seu alcance.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">A
</font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
também não se responsabiliza, na medida do quanto permitido pelo
ordenamento jurídico, pelas perdas, danos e lucros cessantes que
possam decorrer do uso da Plataforma ou dos Serviços, inclusive, mas
não se limitando, no que diz respeito à qualidade, legalidade,
confiabilidade, utilidade, veracidade, exatidão, exaustividade,
precisão, completude e atualidade.</font></font></font></p>
<p style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Os
Usuários concordam em isentar a </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
e seus diretores, funcionários, parceiros e colaboradores, de todos
e quaisquer danos, perdas, responsabilidades e despesas resultantes
de disputas que venham a travar com terceiros, em conexão com a
utilização da Plataforma ou dos Serviços nela contidos.</font></font></font></p>
<p style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Os
Usuários concordam em indenizar a </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
e seus diretores, funcionários, parceiros e colaboradores, por todos
e quaisquer danos, perdas, responsabilidades, demandas, custos e
despesas resultantes de reivindicações ou investigações feitas
por terceiros e que estejam relacionadas ao uso e acesso da
Plataforma e dos Serviços ou à violação destes Termos de Uso ou
de direitos de terceiros. As obrigações de indenização aqui
apontadas permanecerão em vigor após o encerramento ou expiração
deste Acordo ou uso deste Plataforma ou dos Serviços.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ol type="I" start="8">
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>DIREITOS
	DE PROPRIEDADE INTELECTUAL</b></font></font></font></p>
</ol>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">A
</font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
é titular de todos os direitos de propriedade intelectual constantes
da Plataforma e dos Serviços nela disponibilizados (logomarca,
textos, imagens, protocolos, vídeos etc.), os quais encontram-se
protegidos pela lei brasileira e por tratados internacionais. </font></font></font>
</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">O
uso da Plataforma e a oferta dos Serviços nela disponibilizados não
implica em nenhuma concessão de direito para o uso da marca
registrada “</font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
ecotech</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">”</font></font></font><font color="#000000"><sup><font face="Arial, serif"><font size="3" style="font-size: 12pt">®</font></font></sup></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
e o dos logos exibidos na Plataforma.</font></font></font></p>
<p style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Alguns
recursos da Plataforma podem permitir que o </font></font></font><font face="Arial, serif"><font size="3" style="font-size: 12pt">usuário</font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
veicule conteúdos, incluindo </font></font></font><font face="Arial, serif"><font size="3" style="font-size: 12pt">comentários,
opiniões,</font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
recomendações, orientações, entre outros. Ao utilizar a
Plataforma, o Contratante declara ser o proprietário e responsável
por todo o conteúdo que eventualmente venha a postar e, assim,
reconhece que a </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
não endossa, apoia ou tem qualquer ligação com o teor publicado do
mesmo. O Contratante também declara possuir todos os direitos
necessários à disponibilização do conteúdo postado, e que o
mesmo ele não viola a legislação aplicável e os direitos de
terceiros.</font></font></font></p>
<p style="margin-left: 1.25cm; margin-bottom: 0cm; line-height: 100%">
<br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">A
Plataforma Vert Ecotech se reserva ao direito de, a seu critério,
editar ou deixar de veicular, no todo ou em parte, qualquer conteúdo
produzido pelo Usuário, que viole os direitos de propriedade
intelectual de terceiros, bem como sejam considerados ilegais,
agressivos ou ofensivos para com os direitos humanos, sem prejuízo
da imediata suspensão da conta do responsável pela infração.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ol type="I" start="9">
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>SUCESSORES
	E CESSIONÁRIOS</b></font></font></font></p>
</ol>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Este
acordo </font></font></font><font face="Arial, serif"><font size="3" style="font-size: 12pt">vincula</font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
e reverterá em benefício das partes e seus respectivos
herdeiros, sucessores e cessionários.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Sem
Terceiros Beneficiados</b></font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Nada
neste Acordo deve ser considerado como concedendo direitos ou
benefícios a terceiros.</font></font></font></p>
<p align="justify" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 150%">
<br/>

</p>
<ol type="I" start="10">
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>ALTERAÇÃO
	DOS TERMOS DE USO</b></font></font></font></p>
</ol>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Este
Acordo poderá ser alterado a qualquer tempo, com vistas ao seu
aprimoramento e à melhoria de sua segurança. Os novos Termos de Uso
entrarão em vigor na data da sua disponibilização na área
adequada da Plataforma.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Se
você não concordar com as novas regras dos Termos de Uso, você não
deverá usar ou acessar a Plataforma ou os Serviços nela contidos. </font></font></font>
</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ol type="I" start="11">
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>LEI
	APLICÁVEL E FORO DE ELEIÇÃO</b></font></font></font></p>
</ol>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">O
presente Acordo é regido única e exclusivamente pelas leis
brasileiras, sendo que qualquer ação judicial derivada de sua
interpretação ou aplicação deverá ser julgada pelo Poder
Judiciário Brasileiro.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Fica
eleito o foro da Comarca de </font></font></font><font face="Arial, serif"><font size="3" style="font-size: 12pt">Campinas</font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">,
Estado de São Paulo, para resolução de eventuais conflitos
oriundos deste Termo, com exclusão de qualquer outro, por mais
privilegiado que seja.</font></font></font></p>
<p style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ol type="I" start="12">
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>INFORMAÇÕES
	DE CONTATO</b></font></font></font></p>
</ol>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Se
você tiver dúvidas sobre este Acordo, entre </font></font></font><font face="Arial, serif"><font size="3" style="font-size: 12pt">em
contato conosco</font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"> nos seguintes endereços, via correspondência física,
mensagem via website ou e-mail:<br/>
</font></font></font><br/>

</p>
<p align="justify" style="margin-left: 1.27cm; text-indent: -1.27cm; margin-bottom: 0cm; line-height: 150%">
<font color="#000000">• <font face="Arial, serif"><font size="3" style="font-size: 12pt">	</font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Endereço</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">:
Avenida José Rocha Bomfim, nº 214, Bloco B, cj. 214, Loteamento
Center Santa Genebra, CEP 13080-650, ou por intermédio dos canais de
contato disponíveis em nosso website </font></font></font><a href="http://www.vertecotech.com/"><font face="Arial, serif"><font size="3" style="font-size: 12pt">http://www.vertecotech.com</font></font></a><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
 </font></font></font>
</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000">•
<font face="Arial, serif"><font size="3" style="font-size: 12pt">	</font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>E-mail</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">:
</font></font></font><a href="mailto:dpo@vertecotech.com"><font face="Arial, serif"><font size="3" style="font-size: 12pt">dpo@vertecotech.com</font></font></a></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font face="Arial, serif"><font size="3" style="font-size: 12pt">.</font></font></p>
<div title="footer"><p align="right" style="margin-top: 2.26cm; margin-bottom: 0cm; line-height: 100%">
	<span style="background: #c0c0c0"><sdfield type=PAGE subtype=RANDOM format=PAGE></sdfield></span></p>
</div>
</body>
</html>
`;